export default function If(props: { children?: any; cond: boolean }) {
  const { children, cond } = props;
  return cond ? children : null;
}
